@let groups = widgetStore.contentSg();

<div class="scorecard">
  <div class="scorecard__grid">
    @for (group of groups; track $index) {
      <div class="scorecard__card">
        <!-- Label -->
        <div class="scorecard__label">
          <span class="scorecard__label-text">{{ group.name }}</span>
        </div>

        <!-- Table substitute + Summary -->
        <div class="scorecard__content">
          <div class="scorecard__table">
            <!-- Header -->
            <div class="scorecard__row scorecard__row--header">
              <div class="scorecard__cell scorecard__header">Criteria</div>
              <div
                class="scorecard__cell scorecard__header scorecard__header--center"
              >
                Score
              </div>
              <div class="scorecard__cell scorecard__header">Notes</div>
            </div>

            <!-- Data Rows -->
            @for (val of group.values; track val) {
              <div class="scorecard__row">
                <div class="scorecard__cell">{{ val.name }}</div>
                <div class="scorecard__cell scorecard__cell--center">
                  <span
                    class="scorecard__score"
                    [ngClass]="{
                      'scorecard__score--positive':
                        val.value?.quality === Quality.Good,
                      'scorecard__score--neutral':
                        val.value?.quality === Quality.Neutral,
                      'scorecard__score--negative':
                        val.value?.quality === Quality.Bad,
                    }"
                    >{{ val.value?.emphasis }}</span
                  >
                </div>
                <div class="scorecard__cell scorecard__cell--aside">
                  {{ val.value?.aside }}
                </div>
              </div>
            }
          </div>

          <div class="scorecard__summary">
            <span class="scorecard__summary-label">Summary:</span>
            {{ group.description }}
          </div>
        </div>
      </div>
    }
  </div>
</div>
